// Wine catalog — Casa Vino, Vino artisanale di Puglia
// Real producer: Maison Bonsegna (Salento, Pouilles - Italie)
// Source: PDF catalog provided by the client (18 photos, 16 cuvées + 3 formats Primo).

export const WINE_COLORS = {
  red:   { id: "red",   label: "Rouges", labelIt: "Rossi",   accent: "#5B2333" },
  white: { id: "white", label: "Blancs", labelIt: "Bianchi", accent: "#C5A059" },
  rose:  { id: "rose",  label: "Rosés",  labelIt: "Rosati",  accent: "#B85C6F" },
};

const img = (id) => `/wines/${id}.png`;
const PRODUCER = "Maison Bonsegna";
const COMMON_DESC_RED =
  "Fruit du terroir ensoleillé des Pouilles, fidèle au savoir-faire de la maison Bonsegna.";

// ===================== ROUGES =====================
const REDS = [
  {
    id: "cenate-vecchie-rosso",
    name: "Cenate Vecchie Rosso",
    color: "red",
    origin: "Salento, Pouilles — Italie",
    region: "Salento IGP",
    appellation: "Salento IGP",
    grape: "Malvasia Nera · Negroamaro",
    abv: "13,5%",
    serving: "18 - 20 °C",
    pairing: "Idéal avec les pâtes à la tomate, pizza et charcuterie italienne.",
    nose: "Robe rubis · nez fruité, souple, accessible.",
    description:
      "Fruit du terroir ensoleillé des Pouilles, ce vin rouge convivial exprime tout l'esprit du Salento. Une cuvée souple, fidèle au savoir-faire de la maison Bonsegna.",
    price: 5.5,
    format: "75 cl",
    image: img("cenate-vecchie-rosso"),
    featured: true,
  },
  {
    id: "baia-di-uluzzo-sangiovese",
    name: "Baia di Uluzzo Sangiovese",
    color: "red",
    origin: "Salento, Pouilles — Italie",
    region: "Salento IGP",
    appellation: "Salento IGP",
    grape: "100% Sangiovese",
    abv: "13%",
    serving: "18 - 20 °C",
    pairing: "Idéal avec la volaille rôtie, le ragù et les fromages doux.",
    nose: "Nez expressif, fruits rouges et notes florales, tanins fins.",
    description:
      "Le Sangiovese revisité par le soleil des Pouilles. Une cuvée élégante et accessible, fidèle au savoir-faire de la maison Bonsegna.",
    price: 6.9,
    format: "75 cl",
    image: img("baia-di-uluzzo-sangiovese"),
    featured: false,
  },
  {
    id: "baia-di-uluzzo-primitivo",
    name: "Baia di Uluzzo Primitivo",
    color: "red",
    origin: "Salento, Pouilles — Italie",
    region: "Salento IGP",
    appellation: "Salento IGP",
    grape: "100% Primitivo",
    abv: "14,5%",
    serving: "18 - 20 °C",
    pairing: "Idéal avec les viandes grillées, le gibier et les fromages affinés.",
    nose: "Robe pourpre dense, fruits noirs confits, finale épicée et structurée.",
    description:
      "Un Primitivo généreux et solaire, expression directe du terroir du Salento. Tanins veloutés, longueur épicée. Fidèle au savoir-faire de la maison Bonsegna.",
    price: 7.9,
    format: "75 cl",
    image: img("baia-di-uluzzo-primitivo"),
    featured: true,
  },
  {
    id: "baia-di-uluzzo-negroamaro",
    name: "Baia di Uluzzo Negroamaro",
    color: "red",
    origin: "Salento, Pouilles — Italie",
    region: "Salento IGP",
    appellation: "Salento IGP",
    grape: "100% Negroamaro",
    abv: "13%",
    serving: "18 - 20 °C",
    pairing: "Idéal avec des plats mijotés et des viandes rouges.",
    nose: "Notes intenses de fruits rouges, avec un caractère marqué et profond.",
    description:
      "Fruit du terroir ensoleillé des Pouilles, ce vin rouge à base de Negroamaro révèle une expression intense et authentique. Une cuvée de caractère, fidèle au savoir-faire de la maison Bonsegna.",
    price: 7.9,
    format: "75 cl",
    image: img("baia-di-uluzzo-negroamaro"),
    featured: false,
  },
  {
    id: "danze-della-contessa-rosso",
    name: "Danze della Contessa Rosso",
    color: "red",
    origin: "Nardò, Pouilles — Italie",
    region: "Nardò DOC",
    appellation: "Nardò DOC",
    grape: "80% Negroamaro · 20% Malvasia Nera",
    abv: "13,5%",
    serving: "18 - 20 °C",
    pairing: "Idéal pour tous les plats et les viandes grillées.",
    nose: "Arômes intenses de fruits rouges, exprimant toute la profondeur du vin.",
    description:
      "Fruit du terroir ensoleillé des Pouilles, ce vin rouge exprime un caractère intense et affirmé. Une cuvée de caractère, fidèle au savoir-faire de la maison Bonsegna.",
    price: 8.4,
    format: "75 cl",
    image: img("danze-della-contessa-rosso"),
    featured: true,
  },
  {
    id: "danze-della-contessa-rosso-barricato",
    name: "Danze della Contessa Rosso Barricato",
    color: "red",
    origin: "Nardò, Pouilles — Italie",
    region: "Salento IGP",
    appellation: "Salento IGP",
    grape: "80% Negroamaro · 20% Malvasia Nera",
    abv: "13,5%",
    aging: "6 mois en fût de chêne et 3 mois en bouteille",
    serving: "18 - 20 °C",
    pairing: "Idéal avec des plats de viandes rouges et des fromages secs de caractère.",
    nose: "Arômes intenses et profonds, révélant le caractère du vin.",
    description:
      "Fruit du terroir ensoleillé des Pouilles, ce vin rouge exprime un caractère intense et affirmé. Une cuvée de caractère, fidèle au savoir-faire de la maison Bonsegna.",
    price: 10.0,
    format: "75 cl",
    image: img("danze-della-contessa-rosso-barricato"),
    featured: false,
  },
  {
    id: "danze-della-contessa-barricato-1l5",
    name: "Danze della Contessa Rosso Barricato — 1,5 L",
    color: "red",
    origin: "Nardò, Pouilles — Italie",
    region: "Nardò DOC",
    appellation: "Nardò DOC",
    grape: "80% Negroamaro · 20% Malvasia Nera",
    abv: "13,5%",
    aging: "6 mois en fût de chêne et 3 mois en bouteille",
    serving: "18 - 20 °C",
    pairing:
      "Idéal avec des viandes rouges, plats mijotés, grillades, fromages affinés et secs.",
    nose: "Arômes intenses de fruits rouges et notes épicées.",
    description:
      "Fruit du terroir ensoleillé des Pouilles, ce vin rouge exprime un caractère intense et affirmé. Une cuvée de caractère en grand format 1,5 L, fidèle au savoir-faire de la maison Bonsegna.",
    price: 26.0,
    format: "1,5 L",
    image: img("danze-della-contessa-barricato-1l5"),
    featured: false,
  },
  {
    id: "narthos-rosso-riserva-doc",
    name: "Narthos Rosso Riserva DOC",
    color: "red",
    origin: "Pouilles — Italie",
    region: "Puglia DOC",
    appellation: "Puglia DOC Riserva",
    grape: "80% Negroamaro · 20% Malvasia Nera",
    abv: "13%",
    aging: "18 mois en fût d'acacia et 6 mois en bouteille",
    serving: "18 - 20 °C",
    pairing: "Idéal avec des plats de viande grillée et des fromages forts en goût.",
    nose: "Arômes profonds et intenses, révélant un vin de caractère.",
    description:
      "Fruit du terroir ensoleillé des Pouilles, ce vin rouge de caractère séduit par sa profondeur et son élégance. Une cuvée structurée et expressive, fidèle au savoir-faire de la maison Bonsegna.",
    price: 12.0,
    format: "75 cl",
    image: img("narthos-rosso-riserva-doc"),
    featured: true,
  },
  {
    id: "narthos-primitivo",
    name: "Narthos Primitivo",
    color: "red",
    origin: "Pouilles — Italie",
    region: "Puglia DOC",
    appellation: "Puglia DOC",
    grape: "100% Primitivo",
    abv: "16%",
    serving: "18 - 20 °C",
    pairing: "Idéal avec des viandes maturées et du gibier.",
    nose: "Vin de caractère, intense et bien structuré.",
    description:
      "Fruit du terroir ensoleillé des Pouilles, ce vin rouge à base de Primitivo exprime toute sa puissance et son caractère. Une cuvée bien structurée, fidèle au savoir-faire de la maison Bonsegna.",
    price: 16.0,
    format: "75 cl",
    image: img("narthos-primitivo"),
    featured: true,
  },
];

// Primo Rosso Salentino — 4 formats (separate products as requested by the client)
const PRIMO_BASE = {
  name: "Primo Rosso Salentino",
  color: "red",
  origin: "Salento, Pouilles — Italie",
  region: "Salento IGP",
  appellation: "Salento IGP",
  grape: "50% Primitivo · 50% Negroamaro",
  abv: "16%",
  aging: "8 mois en fût de chêne et 6 mois en bouteille",
  serving: "18 - 20 °C",
  pairing:
    "Idéal avec de grands plats à base de viande et des fromages secs.",
  nose: "Arômes intenses et profonds, révélant un vin de caractère.",
  description:
    "Fruit du terroir ensoleillé des Pouilles, ce vin rouge barricato exprime puissance et élégance. Une cuvée mûrie en fût de chêne, fidèle au savoir-faire de la maison Bonsegna.",
};

const PRIMO_FORMATS = [
  { id: "primo-rosso-salentino-75cl", format: "75 cl",  price: 16.0, featured: true  },
  { id: "primo-rosso-salentino-1l5",  format: "1,5 L", price: 35.0, featured: false },
  { id: "primo-rosso-salentino-3l",   format: "3 L",   price: 75.0, featured: false },
  { id: "primo-rosso-salentino-5l",   format: "5 L",   price: 100.0, featured: false },
];

const PRIMOS = PRIMO_FORMATS.map((f) => ({
  ...PRIMO_BASE,
  id: f.id,
  name: `${PRIMO_BASE.name} — ${f.format}`,
  price: f.price,
  format: f.format,
  image: img("primo-rosso-salentino"),
  featured: f.featured,
}));

// ===================== BLANCS =====================
const WHITES = [
  {
    id: "cenate-vecchie-bianco",
    name: "Cenate Vecchie Bianco",
    color: "white",
    origin: "Salento, Pouilles — Italie",
    region: "Salento IGP",
    appellation: "Salento IGP",
    grape: "Malvasia Bianca",
    abv: "12%",
    serving: "6 - 8 °C",
    pairing:
      "Idéal avec des antipasti de poisson, des fruits de mer et des plats de poisson.",
    nose: "Vin sec et frais.",
    description:
      "Vin blanc sec à base de Malvasia Bianca, frais et agréable. Une cuvée simple et authentique, idéale pour accompagner les saveurs de la mer, fidèle au savoir-faire de la maison Bonsegna.",
    price: 5.5,
    format: "75 cl",
    image: img("cenate-vecchie-bianco"),
    featured: true,
  },
  {
    id: "danze-della-contessa-blanc",
    name: "Danze della Contessa Blanc",
    color: "white",
    origin: "Salento, Pouilles — Italie",
    region: "Salento IGP",
    appellation: "Salento IGP",
    grape: "100% Chardonnay",
    abv: "13,5%",
    serving: "6 - 8 °C",
    pairing:
      "Idéal avec des antipasti, des fromages frais et des plats légers.",
    nose: "Vin doré aux senteurs fleuries.",
    description:
      "Vin blanc élégant à base de Chardonnay, à la robe dorée et aux arômes délicats. Une cuvée florale et harmonieuse, idéale pour des moments frais et gourmands, fidèle au savoir-faire de la maison Bonsegna.",
    price: 7.8,
    format: "75 cl",
    image: img("danze-della-contessa-blanc"),
    featured: true,
  },
  {
    id: "narthos-moscato",
    name: "Narthos Moscato (pas sucré)",
    color: "white",
    origin: "Pouilles — Italie",
    region: "Puglia DOC",
    appellation: "Puglia DOC",
    grape: "100% Moscato",
    abv: "14,5%",
    serving: "6 - 8 °C",
    pairing:
      "Idéal avec des poissons crus ou cuits, crustacés et mollusques.",
    nose: "Vin blanc fruité, sec malgré le cépage Moscato.",
    description:
      "Vin blanc fruité élaboré à partir de raisin Moscato, offrant fraîcheur et gourmandise sans sucrosité marquée. Une cuvée expressive et équilibrée, idéale pour accompagner les saveurs marines, fidèle au savoir-faire de la maison Bonsegna.",
    price: 12.0,
    format: "75 cl",
    image: img("narthos-moscato"),
    featured: false,
  },
];

// ===================== ROSÉS =====================
const ROSES = [
  {
    id: "cenate-vecchie-rosato",
    name: "Cenate Vecchie Rosato",
    color: "rose",
    origin: "Salento, Pouilles — Italie",
    region: "Salento IGP",
    appellation: "Salento IGP",
    grape: "Negroamaro · Malvasia Nera",
    abv: "13%",
    serving: "12 - 14 °C",
    pairing:
      "Idéal à l'apéritif, avec des antipasti légers et des viandes blanches.",
    nose: "Vin fruité, frais et agréable.",
    description:
      "Vin rosé fruité issu d'un assemblage de Negroamaro et de Malvasia Nera. Une cuvée fraîche et agréable, idéale pour l'apéritif et les plats légers, fidèle au savoir-faire de la maison Bonsegna.",
    price: 5.5,
    format: "75 cl",
    image: img("cenate-vecchie-rosato"),
    featured: false,
  },
  {
    id: "danze-della-contessa-rosato",
    name: "Danze della Contessa Rosato",
    color: "rose",
    origin: "Salento, Pouilles — Italie",
    region: "Salento IGP",
    appellation: "Salento IGP",
    grape: "Negroamaro · Malvasia Nera",
    abv: "13%",
    serving: "12 - 14 °C",
    pairing: "Idéal pour tous les antipasti et plats variés.",
    nose: "Vin rosé foncé, intense et expressif.",
    description:
      "Vin rosé foncé et intense, issu d'un assemblage de Negroamaro et de Malvasia Nera. Une cuvée expressive et structurée, idéale pour accompagner aussi bien les antipasti que de nombreux plats, fidèle au savoir-faire de la maison Bonsegna.",
    price: 7.8,
    format: "75 cl",
    image: img("danze-della-contessa-rosato"),
    featured: true,
  },
  {
    id: "narthos-rosato",
    name: "Narthos Rosato (pas sucré)",
    color: "rose",
    origin: "Pouilles — Italie",
    region: "Puglia DOC",
    appellation: "Puglia DOC",
    grape: "Negroamaro · Malvasia Nera",
    abv: "14,5%",
    serving: "6 - 8 °C",
    pairing:
      "Idéal avec poissons crus ou cuits, crustacés, mollusques et antipasti.",
    nose: "Arômes de fruits rouges, notes méditerranéennes.",
    description:
      "Ce rosé italien provenant des Pouilles séduit par son équilibre et son élégance. Issu des cépages Negroamaro et Malvasia Nera, il présente une belle robe rosé corail et des arômes délicats de fruits rouges et d'herbes méditerranéennes.",
    price: 12.0,
    format: "75 cl",
    image: img("narthos-rosato"),
    featured: true,
  },
];

// All wines — each entry carries `producer` automatically.
export const WINES = [...REDS, ...PRIMOS, ...WHITES, ...ROSES].map((w) => ({
  ...w,
  producer: PRODUCER,
}));

export const featuredWines = () => WINES.filter((w) => w.featured);
export const winesByColor = (color) =>
  color ? WINES.filter((w) => w.color === color) : WINES;
export const findWine = (id) => WINES.find((w) => w.id === id);
